import { useState, useEffect } from 'react';

/**
 * Devuelve el valor recibido pero "retrasado" `delay` ms: mientras cambia
 * rapido (alguien tipeando) no se actualiza, y recien cuando se detiene toma
 * el ultimo valor. Sirve para no dispararle una request al backend por tecla.
 *
 * VIVE EN `hooks/` Y NO AL LADO DE SU PRIMER CONSUMIDOR porque "retrasar un
 * valor" no tiene nada que ver con animales, ni con ningun dominio: es una
 * primitiva. Es el caso que describe la convencion de AGENTS.md — colocado si
 * lo consume un area concreta, `hooks/` si cruza dominios.
 *
 * Se muda ahora, con UN consumidor, y no despues: `pages/Ventas/
 * SelectComprador.jsx` ya se armo la misma idea a mano con un `debounceRef`,
 * asi que el proximo listado con buscador iba a copiar estas siete lineas por
 * tercera vez. Mudar cuesta un archivo; deduplicar tres copias que ya
 * divergieron cuesta decidir cual era la buena.
 */
export default function useDebouncedValue(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
